import React, { useState } from 'react';
import { CheckCircle2, Loader2, Paperclip } from 'lucide-react';
import { toast } from 'sonner';
import { api, errMsg } from '../api';

export const CANDIDATE_DOCS = [['cv', 'CV del candidato'], ['release', 'Lettera di manleva firmata dal candidato']];

export default function DocUpload({ kind, label, value, onChange }) {
  const [busy, setBusy] = useState(false);
  const pick = async (file) => {
    const fd = new FormData(); fd.append('kind', kind); fd.append('file', file); setBusy(true);
    try { const r = await api.post('/requests/uploads', fd); onChange(r.data); toast.success(`${label} caricato`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <label className={`flex items-center gap-3 border rounded-sm px-3 h-11 cursor-pointer text-sm w-full sm:w-[26rem] ${value ? 'border-[#2E9E6A]/60' : 'border-dashed border-[#3A3F47] hover:border-[#D4AF37]'}`} data-testid={`request-upload-${kind}`}>
      {busy ? <Loader2 size={16} className="animate-spin text-[#D4AF37]" /> : value ? <CheckCircle2 size={16} className="text-[#2E9E6A]" /> : <Paperclip size={16} className="text-[#D4AF37]" />}
      <span className="flex-1 min-w-0 truncate">{value ? value.filename : `${label} *`}</span>
      <span className="text-xs text-[#7A7F87] shrink-0">{value ? 'Cambia' : 'PDF, Word, JPG, PNG'}</span>
      <input type="file" accept=".pdf,.doc,.docx,image/jpeg,image/png" className="hidden" onChange={(e) => { if (e.target.files[0]) pick(e.target.files[0]); e.target.value = ''; }} data-testid={`request-upload-${kind}-input`} />
    </label>
  );
}
